import React from "react";
import styles from "./style.module.scss";
import cx from "classnames";
import { Col, Row, Container, Table } from "reactstrap";
import { toNumberFormat } from "utils/Utils";

const TotalSummaryTable = (props) => {
  const { className, data, currency = "USD" } = props;

  const formatValue = (value) => {
    return toNumberFormat(value)

  }

  const createTableEntries = () => {
    return data.map(v => {
      const { hideOnZero = false } = v;
      return (v.value > 0 || !hideOnZero) && (
        <tr>
          <th scope="row">
            {v.label}
          </th>
          <td className={styles.valueColumn}>
            {`${formatValue(v.value)} ${currency}`}
          </td>
        </tr >
      );
    })

  }

  return (
    <>
      <Table className={className}>
        <tbody>
          {createTableEntries()}
        </tbody>
      </Table>
    </>
  );
}

export default TotalSummaryTable;